import { render, staticRenderFns } from "./OrdingPrice.vue?vue&type=template&id=7d85f654&scoped=true"
import script from "./OrdingPrice.vue?vue&type=script&lang=js"
export * from "./OrdingPrice.vue?vue&type=script&lang=js"
import style0 from "./OrdingPrice.vue?vue&type=style&index=0&id=7d85f654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85f654",
  null
  
)

export default component.exports